import CreditCardsNewForm from '../../components/pages/credit_cards/credit-cards-new-form.vue'
export default {
  components: { CreditCardsNewForm }
}
